/**
 * Mock recall board logic (alignment map V1-F7-09b MockRecall; F7.9): the lot balance of each
 * farmer lot (v_lot_balance) as the board's shares of the gate kilos, and what is still at the
 * hall per pack lot. Integer grams.
 */
export interface LotBalance {
  lotId: string
  lotCode: string
  gateG: number
  inLotBagsG: number
  brandBatchG: number
  convBatchG: number
  byproductG: number
  wasteG: number
  brandPackedG: number
  accountedG: number
  accountedPct: number | null
  lostG: number
  overPacked: boolean
  openRuns: number
}

export interface BalanceShare {
  key: string
  label: string
  g: number
  pct: number | null
}

const share = (g: number, of: number) => (of > 0 ? Math.round((g * 1000) / of) / 10 : null)

/** The board's lines: brand pouches, by-product, brand stock not yet packed, red tie, waste, losses. */
export function balanceShares(b: LotBalance): BalanceShare[] {
  const lines: Array<[string, string, number]> = [
    ['packed', 'Brand pouches', b.brandPackedG],
    ['byproduct', 'Shells (by-product)', b.byproductG],
    ['brand', 'Brand stock not yet packed (sacks)', b.brandBatchG],
    ['lot', 'Still in the farmer’s own sacks', b.inLotBagsG],
    ['conv', 'Red tie (ordinary)', b.convBatchG],
    ['waste', 'Rejects and waste', b.wasteG],
    ['lost', 'Recorded losses', b.lostG],
  ]
  return lines
    .filter(([key, , g]) => g !== 0 || key === 'packed' || key === 'lost')
    .map(([key, label, g]) => ({ key, label, g, pct: share(g, b.gateG) }))
}

/** Pouches still at the hall: packed − dispatched (never below 0). */
export function stillAtHall(p: { pouches: number | null; pouchesDispatched: number }): number {
  return Math.max(0, (p.pouches ?? 0) - p.pouchesDispatched)
}

/** "4.2 s" */
export function seconds(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—'
  return `${(ms / 1000).toFixed(1)} s`
}
